import { ElementType } from 'react';

function isValuable(type: ElementType): boolean {
  // @ts-ignore
  const { propTypes } = type;
  return propTypes ? 'value' in propTypes : false;
}

export default isValuable;
